import type { ScoOption } from '~/pages/scorm/sco-navigation'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from '~/components/ui/button'
import FinishedScreen from './FinishedScreen'

type Props = {
  /** Le chapitre qui vient de rendre la main est-il terminé ? */
  completed: boolean
  /** Le prochain chapitre à faire ; aucun quand tous les autres le sont. */
  next: ScoOption | undefined
  /** Finir ce module clôt aussi le parcours (#26). */
  completesPath: boolean
  onNext: (identifier: string) => void
  fallbackTo: string
  fallbackLabel: string
}

/**
 * Fin d'un chapitre (#160). Terminé, il propose le suivant — ou, s'il était le
 * dernier à faire, dit la fin du module. Quitté sans être terminé, il le dit,
 * et propose quand même d'aller ailleurs.
 */
function ScoFinished({ completed, next, completesPath, onNext, fallbackTo, fallbackLabel }: Props) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const moduleDone = completed && !next

  const title = moduleDone
    ? t(completesPath ? 'scorm.finished.pathCompletedTitle' : 'scorm.finished.completedTitle')
    : t(completed ? 'scorm.chapters.finishedTitle' : 'scorm.chapters.leftTitle')

  return (
    <FinishedScreen title={title} success={completed}>
      {moduleDone && completesPath && <p className="text-sm">{t('scorm.finished.pathCompletedHint')}</p>}
      {next && <Button onClick={() => onNext(next.identifier)}>{t('scorm.chapters.next', { title: next.title })}</Button>}
      <Button variant={next ? 'outline' : 'default'} onClick={() => navigate(fallbackTo)}>{fallbackLabel}</Button>
    </FinishedScreen>
  )
}

export default ScoFinished
